export enum EntityType {
  Asset = 'asset',
  AssetGroup = 'assetgroup',
  Geozone = 'geozone',
  SubCompany = 'sub-company'
}
